import { useParams } from 'react-router-dom';
import { TransactionWarningActionBody, TransactionWarnings } from '@ui/src';
import { useAppSelector, useAppDispatch } from '@store';
import { useApplyInternalTransactionWarningActionMutation } from '../../internal/store/services';
import {
  changePanelState,
  setBlacklistDataVisible,
  setBlacklistData,
} from '../store/slices/transaction-fee';

const TransactionFeeWarning = (): React.JSX.Element => {
  const {
    transactionFee: { warnings },
    transactions: { employee },
    transactionsDictionaries: { transactionsTypes },
  } = useAppSelector((state) => state);

  const { transactionId } = useParams();

  const dispatch = useAppDispatch();

  const [applyInternalTransactionWarning] =
    useApplyInternalTransactionWarningActionMutation();

  const onApplyTransactionAction = ({
    body,
    warningId,
  }: {
    body: TransactionWarningActionBody;
    warningId: string;
  }) => {
    applyInternalTransactionWarning({
      transactionId: transactionId as string,
      body,
      warningId,
    });
  };

  return (
    <TransactionWarnings
      warnings={warnings}
      employee={employee}
      onApplyTransactionAction={onApplyTransactionAction}
      transactionsTypes={transactionsTypes}
      setBlacklistDataVisible={(visible) => {
        dispatch(setBlacklistDataVisible(visible));
        dispatch(changePanelState({ state: false }));
      }}
      setBlacklistData={(data) => dispatch(setBlacklistData(data))}
      isInternal
    />
  );
};

export default TransactionFeeWarning;
